import reduce from 'lodash/reduce';
import moment from 'moment';
import assignIn from 'lodash/assignIn';
import isString from 'lodash/isString';
import isFinite from 'lodash/isFinite';
import isArray from 'lodash/isArray';
import isNil from 'lodash/isNil';
import get from 'lodash/get';
import mapKeys from 'lodash/mapKeys';
import startOfDay from 'date-fns/start_of_day';

import * as equipment from './equipment';
import { getUrlQeury } from './formatUrlquery';
import { milliseconds } from 'date-fns';


const defaultMiles = 200;

const getNextMonth = (date) => {
  return moment(date).add(1,'month')
}

export const DEFAULTS = {
  initialLimit: 50,
  limit: 50,
};
// here is real define initial value place
const queryDefaults = {
  limit: DEFAULTS.initialLimit,
  sort_order: 'asc',
  sort_by: 'age',
  show_option: 'All',
  dho: defaultMiles,
  dhd: defaultMiles,
  weight:"any",
  length:''
};

export const weightEnum = {
  any: {
    min: null,
    max: null,
  },
  min: {
    min: 0,
    max: 26000,
  },
  upperMin: {
    min: 26001,
    max: 33000,
  },
  middle: {
    min: 33001,
    max: 40000,
  },
  max: {
    min: 40000,
    max: null,
  }
}

const number = (value, fallback = null) => {
  const num = value && parseFloat(value);
  if (isFinite(num)) {
    return num;
  }
  return fallback;
};

export const ensureQueryDefaults = (data) => ({
  ...queryDefaults,
  ...data,
  limit: number(data.limit, queryDefaults.limit),
  sort_order: data.sort_order || queryDefaults.sort_order,
  sort_by: data.sort_by || queryDefaults.sort_by,
});

const getValue = (value) => (isNil(value) ? null : value);

export const coerceQueryTypes = (query) => {
  // reset value type
 const reData = {
   ...query,
   from_city: getValue(query.from_city),
   from_state: getValue(query.from_state),
   from_country: getValue(query.from_country),
   from_lng: number(query.from_lng),
   from_lat: number(query.from_lat),
   from_st: getValue(query.from_st),
   from_name: query.from_name || '',
   to_city: getValue(query.to_city),
   to_state: getValue(query.to_state),
   to_country: getValue(query.to_country),
   to_name: query.to_name || '',
   to_st: getValue(query.to_st),
   to_lng: number(query.to_lng),
   to_lat: number(query.to_lat),
   limit: number(query.limit),
   dho: number(query.dho),
   dhd: number(query.dhd),
   offset: number(query.offset),
   dots: getValue(query.dots) || [],
   length:getValue(query.length) || ''
 };
 return reData;
};

const extractDigits = value =>
  isString(value)
    ? value.replace(/[^\d]/g, '')
    : value;

export const normalizeForm = {
  length: (value) => value && extractDigits(value),
  dho: (value) => value && extractDigits(value),
  dhd: (value) => value && extractDigits(value),
};

export const queryLocation = (prefix, location) => {
  let item = {
    name: location.name,
    country: location.country,
    city: location.city,
    state: location.state,
    st: location.is_state,
  };

  if (!location.is_state) {
    item.lat = location.lat;
    item.lng = location.lng;
  }

  return reduce(item, (result, value, key) => (
    {...result, [`${prefix}_${key}`]: value}
  ), {});
};

export const checkLocations = (origin, destination, dho, dhd) => {
  let result = {};

  if (origin) {
    assignIn(result, queryLocation('from', origin));
    if (!origin.is_state && origin.name) {
      result.dho = dho || 200;
    }
  }

  if (destination) {
    assignIn(result, queryLocation('to', destination));
    if (!destination.is_state && destination.name) {
      result.dhd = dhd || 200;
    }
  }

  return result;
};

export function form2query(data) {
  let result = {
    sort_by: data.sort_by,
    sort_order: data.sort_order,
    limit: data.limit || DEFAULTS.initialLimit,
    offset: data.offset || 0,
  };

  result.date = data.date;
  result.equipment = data.equipment;
  result.loadSize = data.loadSize;

  if (data.dots) {
    result.dots = data.dots || [];
  }


  // result.weight = data.weight;
  // result.emptyWeight =  true;
  // result.length = data.length;
  // result.emptyLength = true;
  // result.dho = data.dho;
  // result.dhd = data.dhd;

  return result;
}

export function fallbackToArray(value) {
  if (isArray(value)) {
    return value;
  } else if (isString(value)) {
    return [value];
  }
  return [];
}

function normalizeStrNum(value) {
  if (isString(value)) {
    return value.replace(',', '.');
  }
  if (isFinite(value)) {
    return value;
  }

  return null;
}

const nullAsString = (value) => value === null ? '' : value;

const getDate = (date, isLandingForm) => {
  if (date) {
    return date;
  }

  return (isLandingForm
    ? []
    : [startOfDay(new Date()),startOfDay(getNextMonth(new Date()))]
  );
};

export function query2form(data, isLandingForm) {
  let result = {
    sort_by: data.sort_by,
    sort_order: data.sort_order,
    limit: data.limit || DEFAULTS.initialLimit,
    offset: data.offset || 0,
    weight:'any',
    length:'',
    date: fallbackToArray(getDate(data.date, isLandingForm)),
  };

  result.equipment = fallbackToArray(data.equipment);
  result.dots = fallbackToArray(data.dots) || [];
  result.dho = nullAsString(normalizeStrNum(data.dho));
  result.dhd = nullAsString(normalizeStrNum(data.dhd));
  result.loadSize = nullAsString(data.loadSize);
  result.weight = nullAsString(data.weight);
  result.emptyWeight = true
  result.length = nullAsString(data.length);
  result.emptyLength = true
  return result;
}

const addKeysPrefix = (prefix, props) =>
  mapKeys(props, (value, key) => `${prefix}${key}`);

const locationName = (isState, city, state) => {
  if (isState) {
    return state;
  }
  if (!city) {
    return '';
  }

  return `${city}, ${state}`;
};

const legacyServerLocationToQuery = (prefix, location) => {
  const isState = get(location, 'location_state') && true;
  const city = get(location, 'description.city');
  const state = get(location, 'description.state');
  const name = locationName(isState, city, state);

  return addKeysPrefix(prefix, {
    city,
    state,
    country: get(location, 'description.country'),
    lng: get(location, 'location.lng'),
    lat: get(location, 'location.lat'),
    st: isState,
    name,
  });
};

export const fromServerLegacy = (query) => coerceQueryTypes({
  ...legacyServerLocationToQuery('from_', query.pick_up),
  ...legacyServerLocationToQuery('to_', query.drop_off),
  dho: get(query, 'pick_up.deadhead'),
  dhd: get(query, 'drop_off.deadhead'),
  sort_by: query.sort_by,
  sort_order: query.sort_order,
  loadSize: query.loadSize,
  equipment: fallbackToArray(query.equipment).map(i => equipment.humanLowerCaseToId[i]),
  weight: query.max_weight,
  date: query.dates,
  limit: query.limit,
  offset: query.offset,
  dots: get(query, 'dots.eq'),
});

export function toServerLegacy(data) {
  const query = getUrlQeury() || {}
  let result = {
    featured_first: false,
    sort_by: data.sort_by,
    sort_order: data.sort_order,
    limit: data.limit,
    offset: data.offset,
  };

  if (data.dots && data.dots.length) {
    result.dots = {eq: data.dots};
  }

  result.equipment = fallbackToArray(data.equipment).map(i => equipment.idToHumanLowerCase[i]);
  result.dates = fallbackToArray(data.date);
  result.load_size = data.loadSize;


  const { max: max_weight, min: min_weight } = weightEnum[data.weight] ||  weightEnum["any"]
  result.max_weight = max_weight;
  result.min_weight = min_weight;
  result.weight_allow_null = data.emptyWeight || false
  result.max_length = data.length;
  result.length_allow_null = data.emptyLength || false
  if (data.from_st) {
    result.pick_up = {
      location_state: data.from_state,
      description: {
        city: null,
        state: data.from_name,
        country: data.from_country,
      },
    };
  } else if (data.from_lat) {
    result.pick_up = {
      location: {
        lat: parseFloat(data.from_lat),
        lng: parseFloat(data.from_lng),
      },
      description: {
        city: data.from_city || data.from_name,
        state: data.from_state,
        country: data.from_country,
      },
    };
    if (isFinite(parseFloat(data.dho))) {
      result.pick_up.deadhead = parseFloat(data.dho);
    }
  } else if (!data.from_lat && !data.from_lng && !data.from_city && query.from_state_name) {
    result.pick_up = {
      location_state: query.from_state_name
    };
  }else if (data.from_state_name_direct) {
    result.pick_up = {
      location_state: data.from_state_name_direct
    };
  }


  if (data.to_st) {
    result.drop_off = {
      location_state: data.to_state,
      descriptions: [{
        city: null,
        state: data.to_name,
        country: data.to_country,
      }],
    };
  } else if (data.to_lat) {
    result.drop_off = {
      location: {
        lat: parseFloat(data.to_lat),
        lng: parseFloat(data.to_lng),
      },
      descriptions: [{
        city: data.to_city || data.to_name,
        state: data.to_state,
        country: data.to_country,
      }],
      deadhead: data.dhd,
    };

    if (isFinite(parseFloat(data.dhd))) {
      result.drop_off.deadhead = parseFloat(data.dhd);
    }
  }
  result.show_option = data.show_option || 'All';
  return result;
}



// WEBPACK FOOTER //
// ./src/misc/search.js